module.exports = __webpack_public_path__ + "img/icon_header_join_w.a6ada635.svg";